<template>
  <div v-if="passwordResetSuccess">
    <div>
      <h1>Password changed</h1>
      <RouterLink to="/user_rooms">Go to rooms</RouterLink>
    </div>
  </div>
  <form v-else @submit.prevent="changePassword">
    <h1>Reset password password</h1>
    <div>
      <input required v-model="password" type="password" placeholder="New password">
    </div>
    <div>
      <input required v-model="confirmPassword" type="password" placeholder="Confirm password">
    </div>
    <div>
      <input type="submit" value="Change password">
    </div>
  </form>
</template>

<script>
import {verifyPasswordResetCode, confirmPasswordReset, getAuth, signInWithEmailAndPassword} from "firebase/auth";

export default {
  name: "HandlePasswordReset",
  props: ["code"],
  data() {
    return {
      password: "",
      confirmPassword: "",
      passwordResetSuccess: false
    }
  },
  methods: {
    async changePassword() {
      try {
        if (this.password !== this.confirmPassword) return alert("Passwords don't match")

        const email = await verifyPasswordResetCode(getAuth(), this.code)
        await confirmPasswordReset(getAuth(), this.code, this.confirmPassword)
        await signInWithEmailAndPassword(getAuth(), email, this.password)

        this.passwordResetSuccess = true
      } catch (e) {
        alert(e)
      }
    }
  }
}
</script>

<style scoped>

</style>